import { api, setTokenProvider } from '../api';
import type { TvStoreApi } from '../store';

export interface DevApiSessionParams {
  /** TV ID token from `POST /v1/dev/tv-token` (DEV-only API route). */
  token: string;
  sid: string;
}

/**
 * Dev-build only: signs the app in with a TV token minted by the local API instead of
 * pairing, so a real session can be driven from a script (`apps/tv/test-e2e`). Unlike
 * `seedDevSession` (static Figma placeholders) every screen then talks to the real API.
 */
export async function seedDevApiSession(
  store: TvStoreApi,
  { token, sid }: DevApiSessionParams,
): Promise<void> {
  setTokenProvider(async () => token);
  const { session } = await api.session({ params: { sid } });
  store.getState().setAuth({
    status: 'signed_in',
    uid: `tv:${session.deviceId}`,
    user: null,
    features: session.features,
  });
  store.getState().setSession(session);
}
